import {createAction, props} from "@ngrx/store";
import {ActionType} from "@/main/emails/store/action.type";

export const changePageAction = createAction(
  ActionType.CHANGE_PAGE,
  props<{page: number, pageSize: number}>()
)
